import style from "./technology-stack.module.scss";
import Image from "next/image";
import SharedAnimation from "@components/shared/animation";
import { InView } from "react-intersection-observer";
import animations from "@styles/animations.module.scss";


 interface Technology {
  name: string;
  logo: string;
  width: number;
  height: number;
}
 interface TechnologySection {
  category: string;
  items: Technology[];
}

type TechnologyStackProps = {
  technologyStack: TechnologySection[];
};

const TechnologyStack  = ({ technologyStack }: TechnologyStackProps) => {
return (
    <SharedAnimation
      render={() => (
        <section className={style.section}>
          <div className={style.techStack__title}>Technology stack used</div>
          <InView triggerOnce>
            {({ inView, ref, entry }) => {
              if (inView) entry?.target.classList.add(animations.active);
              return (
                <div
                  ref={ref}
                  className={`${style.techStack__grid} ${animations.scroll__animation}`}
                >
                  {technologyStack.map((section) => (
                    <div key={section.category} className={style.techStack__row}>
                      <div className={style.techStack__category}>{section.category}</div>
                      <div className={style.techStack__items}>
                        {section.items.map((item: any) => (
                              <div
                                key={item.name}
                                className={`${style.techStack__item} ${section.category === "Mobile development" ? style.techStack__item_mobile : ""}`}
                              >
                            <div className={style.techStack__item__image}>
                              <Image
                                src={item.logo}
                                alt={item.name}
                                width={item.width}
                                height={item.height}
                                className={style.techStack__logo}
                              />
                            </div>
                            <div className={style.techStack__item__name}>{item.name}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              );
            }}
          </InView>
        </section>
      )}
    />
  );
};

export default TechnologyStack;
